import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-textarea',
  imports: [NgClass, NgStyle, FormsModule, TranslateModule],
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextareaComponent),
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor, OnInit {
  @Input() value: string = '';
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() name: string = 'message';
  @Input() id: string = '';
  @Input() required: boolean = false;
  @Input() error?: string;
  @Input() height: number = 128;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  public onChange = (value: string) => {};
  public onTouched = (value: boolean) => {};

  changed(value: string): void {
    this.onChange(value);
  }

  touched(): void {
    this.onTouched(true);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: boolean) => void): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    if (this.id === '') this.id = 'form-id-' + this.name;
  }
}
